module.exports = __webpack_public_path__ + "img/optin-monster.ec853258.svg";